<script setup lang="ts">
  import { IconScan, Text } from '@ui-kit';
</script>

<template>
  <IconScan style="width: 44px; height: 44px;" />
  <Text font="body-regular-12" color="secondary" data-testid="scan-screen-start-text">
    {{ $t('Нажмите кнопку сбоку на сканере') }}
  </Text>
</template>